<template>
  <v-footer app class="pa-0 pr-10 ma-0 " dense inset color="#111">
    <v-container fluid class="pa-0 ma-0 ">
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
        >
          <v-row justify="end">
            <div>{{version}}  &copy; {{ new Date().getFullYear() }}</div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  computed:{
    version: {
      get() {
        const version = require('../../../version.json')
        return version.version
      }
    }
  }
}
</script>


<style>

</style>